(() => {
  const CART_SAVING_ROW_CLASS = 'bn-cart-pack-summary__saving-row';
  const GIFT_SELECTOR = '[data-bn-bundle-gift]';
  let frame = null;
  let observer = null;

  const readBundleCount = (root) => {
    const source = root.querySelector('[data-bundle-count]')
      || root.querySelector('[data-bundle-mobile-count]');
    const match = String(source?.textContent || '').match(/\d+/);
    return match ? Number.parseInt(match[0], 10) || 0 : 0;
  };

  const applyCartSavingStyle = () => {
    document.querySelectorAll('.bn-cart-pack-summary > div').forEach((row) => {
      const label = row.querySelector(':scope > span');
      const value = row.querySelector(':scope > strong');
      if (!label || !value) return;

      const labelText = label.textContent.trim();
      if (!/^ahorr(?:o|as)$/i.test(labelText)) return;

      row.classList.add(CART_SAVING_ROW_CLASS);
      if (label.textContent.trim() !== 'AHORRO') label.textContent = 'AHORRO';

      const positiveValue = value.textContent
        .replace(/^\s*[−–—-]\s*/, '')
        .trim();
      if (value.textContent.trim() !== positiveValue) value.textContent = positiveValue;
    });
  };

  const ensureBundleGiftMessage = (root) => {
    const panel = root.querySelector('[data-bundle-summary-panel]');
    if (!panel) return;

    let gift = panel.querySelector(GIFT_SELECTOR);
    if (!gift) {
      gift = document.createElement('div');
      gift.className = 'bn-bundle-summary__gift';
      gift.dataset.bnBundleGift = '';
      gift.setAttribute('role', 'status');
      gift.setAttribute('aria-live', 'polite');
      gift.hidden = true;

      const title = document.createElement('strong');
      title.textContent = 'REGALO DE LANZAMIENTO CONSEGUIDO';

      const detail = document.createElement('span');
      detail.textContent = 'Sujeto a disponibilidad para los primeros 500 pedidos.';

      gift.append(title, detail);

      const shipping = panel.querySelector('[data-bn-shipping]');
      const submit = panel.querySelector('[data-bundle-submit]');
      const anchor = shipping || submit;
      if (anchor) anchor.insertAdjacentElement('beforebegin', gift);
      else panel.appendChild(gift);
    }

    gift.hidden = readBundleCount(root) < 3;
  };

  const apply = () => {
    applyCartSavingStyle();
    document.querySelectorAll('[data-bundle-builder]').forEach(ensureBundleGiftMessage);
  };

  const queueApply = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = null;
      apply();
    });
  };

  const start = () => {
    apply();
    if (!observer && document.body) {
      observer = new MutationObserver(queueApply);
      observer.observe(document.body, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('pageshow', queueApply);
  document.addEventListener('cart:update', queueApply);
  document.addEventListener('discount:update', queueApply);
  document.addEventListener('shopify:section:load', queueApply);
})();
